import React, { useState, useEffect } from 'react';

const ReverseGeocode = ({ latitude, longitude, showGps = false }) => {
    const [address, setAddress] = useState("");

    useEffect(() => {
        if (!latitude || !longitude) return;
        
        let isMounted = true;
        // Cache heavily based on 4 decimal places (~11 meters) to avoid rate limits
        const cacheKey = `geocode_full_${Number(latitude).toFixed(4)}_${Number(longitude).toFixed(4)}`;
        const cached = sessionStorage.getItem(cacheKey);
        
        if (cached) {
            setAddress(cached);
            return;
        }

        // Delay slightly to prevent rapid firing
        const timer = setTimeout(() => {
            fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&zoom=16&addressdetails=1`, {
                headers: {
                    'Accept-Language': 'en'
                }
            })
                .then(res => res.json())
                .then(data => {
                    if (isMounted && data && data.display_name) {
                        const addr = data.address || {};
                        const parts = [];
                        
                        const local = addr.neighbourhood || addr.suburb || addr.village;
                        const street = addr.road || addr.pedestrian;
                        const city = addr.city || addr.town || addr.county || addr.state_district;
                        
                        if (local) parts.push(local);
                        if (street && !parts.includes(street)) parts.push(street);
                        if (city && !parts.includes(city)) parts.push(city);
                        
                        let finalAddress = parts.length > 0 ? parts.join(', ') : data.display_name.split(',').slice(0, 3).join(',');
                        
                        setAddress(finalAddress);
                        sessionStorage.setItem(cacheKey, finalAddress);
                    }
                })
                .catch(() => {});
        }, 500);

        return () => { 
            isMounted = false; 
            clearTimeout(timer);
        };
    }, [latitude, longitude]);

    const coords = `${Number(latitude).toFixed(5)}, ${Number(longitude).toFixed(5)}`;

    if (!address) {
        return <span>{coords}</span>;
    }

    if (!showGps) {
        return <span className="break-words">{address}</span>;
    }

    return (
        <span className="block">
            <span className="block break-words">{address}</span>
            <span className="block opacity-75 mt-0.5">GPS: {coords}</span>
        </span>
    );
};

export default ReverseGeocode;
